module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/aleg4-2fafae19b01696aafffa8c8c6da024d2.jpg";